<div class="content-wrapper">
  <section class="content">
    <div class="box">
      <div class="box-body">
          <mat-card class="btnCard">
              <!-- <button mat-stroked-button type="button" *ngIf="_global.IsBulkLoad"  (click)="BulkUploadEmployeeRecovery()">{{btnValue}}</button>             -->
              <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
          </mat-card>
          <fieldset>
        <div class="panel panel-default">
          <header class="panel-heading">
            
            <h5 class="panel-title">Bulk Upload</h5>
          </header>
          <div class="panel-body">
            <div class="row input-group radio-div" style="margin: 0px auto; padding-top: 20px; padding-bottom: 0px;">
              <div class="form-group col-md-4">
                &nbsp; &nbsp; <label>Please select file</label>
              </div>
              <div class="form-group col-md-4">
                <input type="file" style="display: inline" accept=".xlsx" (change)="onfilechange($event)">
              </div>
              <div class="form-group col-md-4">
                <span> <a href={{_global.excelPath}}>Download Template</a></span>
              </div>
            </div>
          </div>
          <div class="panel-footer" style="text-align: right">
            <button mat-stroked-button type="button" (click)="UploadAttachment(UploadResponseFileUpload)"
              >Upload</button>
            <button type="button" mat-stroked-button (click)="CancelUploadFile($event);">Cancel</button>
          </div>
        </div>
          </fieldset>
      </div>
    </div>
    <!-- /.box -->
  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->